module.exports = __webpack_public_path__ + "static/media/kn.58415b13.svg";